
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-business-address",
      function () {
        return require("private-next-pages/virtual-business-address.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-business-address"])
      });
    }
  